import { NAVER_WCS_ACCOUNT_ID } from '~constants/variable';

/**
 * 네이버 애널리틱스 전환 추적 함수
 * @param conversionType 전환 타입 (예: 'sign_up', 'purchase' 등)
 */
export function trackNaverConversion(conversionType: string): void {
  if (typeof window === 'undefined' || !window.wcs) {
    return;
  }

  // wcs_add 초기화
  if (!window.wcs_add) {
    window.wcs_add = {};
  }
  window.wcs_add['wa'] = NAVER_WCS_ACCOUNT_ID;

  // 전환 이벤트 설정 및 전송
  const _conv: { [key: string]: string } = {};
  _conv.type = conversionType;
  window.wcs.trans(_conv);
}

export function trackNaverPageView(): void {
  if (typeof window === 'undefined' || !window.wcs) {
    console.log('wcs is not defined');
    return;
  }

  // wcs_add 초기화
  if (!window.wcs_add) {
    window.wcs_add = {};
  }
  window.wcs_add['wa'] = NAVER_WCS_ACCOUNT_ID;
  if (!window._nasa) window._nasa = {};
  if (window.wcs) {
    window.wcs.inflow(window.location.hostname);
    window.wcs_do();
  }
}
